/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StudyProgramLangEnum {
    Romana = 'Romana',
    Engleza = 'Engleza',
    Franceza = 'Franceza',
    Germana = 'Germana',
    RoEn = 'RoEn',
    EnFr = 'EnFr'
}

export function StudyProgramLangEnumFromJSON(json: any): StudyProgramLangEnum {
    return StudyProgramLangEnumFromJSONTyped(json, false);
}

export function StudyProgramLangEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyProgramLangEnum {
    return json as StudyProgramLangEnum;
}

export function StudyProgramLangEnumToJSON(value?: StudyProgramLangEnum | null): any {
    return value as any;
}

